import Cookies from 'js-cookie';
import { createContext, useState,useEffect } from 'react';
import ProfileSetup from '../pages/ProfileSetup/ProfileSetup';

const url=process.env.REACT_APP_ENV==="production"?"https://nuecruit.nuearcus.com":process.env.REACT_APP_API_URL

const userDetails=createContext();

const Parent = ({ children }) => {
    const [user, setUser] = useState({
        "name": Cookies.get('name'),
        "email": Cookies.get('email'),
        "phoneNumber": Cookies.get('phoneNumber'),
        "token": Cookies.get('token'),
        "profile": null  // Add profile data
    });

    const [loading, setLoading] = useState(true);

    // Fetch profile data on mount
    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const userId = Cookies.get('id');
                const token = Cookies.get('token');
                
                const response = await fetch(`${url}/api/profile/profileSetupCompleted?userid=${userId}`, {
                    headers: {
                        'Authorization': `Bearer ${token}`
                    }
                });
                if (response.ok) {
                    const profileData = await response.json();
                    setUser(prev => ({
                        ...prev,
                        profile: profileData.data  // Contains preferredRole, preferredDomain, etc.
                    }));
                }
            } catch (error) {
                console.error('Error fetching profile:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, []);

    if (loading) {
        return <div>Loading...</div>; 
    }

    return (
        <userDetails.Provider value={{ user, setUser }}>
            {children}
        </userDetails.Provider>
    );
};

export { userDetails, Parent };